import api from './axiosConfig';
const url = '/api/inventario';

export const agregarProductos = async (data) => {
  try {
    const response = await api.post(
      url+'/producto/agregar', data, 
      { withCredentials: true }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data.msg || error;
  }
};

export const restarExistencias = async (data) => {
  try {
    const response = await api.post(url+'/producto/restar', data, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data.msg || error;
  }
};

export const obtenerProductos = async () => {
  try {
    const response = await api.get(url+'/ver', {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data.msg || error;
  }
};

export const verPorCodigoBarra = async () => {
  try {
    const response = await api.get(url+'/verPorCodigoBarra', {
      withCredentials: true,
    });
    return response.data.productos;
  } catch (error) {
    throw error.response?.data.msg || error;
  }
};

export const buscarComprobante = async (codigo) => {
  try {
    const response = await api.get(`${url}/comprobante/${codigo}`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data.msg || error;
  }
}

export async function buscarProducto(codigoBarra) {
  try {
    const { data } = await api.get(`${url}/producto/barcode/${encodeURIComponent(codigoBarra)}`);

    // Si API devuelve null/undefined/{} cuando no existe
    if (!data || (typeof data === 'object' && Object.keys(data).length === 0)) {
      return { ok: false, code: 'NOT_FOUND', message: 'No se encontró un producto con ese código de barra.' };
    }
    return { ok: true, data };

  } catch (err) {
    const status = err?.response?.status;
    if (status === 404) {
      return { ok: false, code: 'NOT_FOUND', message: 'No se encontró un producto con ese código de barra.' };
    }
    if (err?.request && !err?.response) {
      return { ok: false, code: 'NETWORK', message: 'No hay conexión o el servidor no respondió.' };
    }
    return { ok: false, code: 'ERROR', message: err?.response?.data?.msg || 'Error del servidor al buscar el producto.' };
  }
}

export const agregarNotaCredito = async (data) => {
  try {
    const response = await api.post(url+'/notacredito/agregar', data, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data.msg || error;
  }
};